// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ServiceNowIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="#62D84E"
      fillRule="evenodd"
      d="M12.06 2.74a10.04 10.04 0 0 0-6.92 17.34 2 2 0 0 0 2.58.13 7.2 7.2 0 0 1 8.56 0 2 2 0 0 0 2.6-.15 10.04 10.04 0 0 0-6.82-17.32M12 17.79a4.87 4.87 0 0 1-5-5 5 5 0 1 1 10 0 4.87 4.87 0 0 1-5 5"
      clipRule="evenodd"
    />
  </svg>,
  "ServiceNow",
);
export default ServiceNowIcon;
